<template>
  <form
    v-if="showForm"
    class="form-floating needs-validation"
    novalidate
    @submit.prevent="submit"
  >
    <textarea
      :id="textAreaReference"
      v-model="form.body"
      class="form-control"
      :class="getValidationClass('body')"
      placeholder="Laissez une note ici"
      name="body"
      style="height: 100px"
      title="Laissez une note ici"
      :disabled="isDisabled"
    ></textarea>
    <label :for="textAreaReference">Commentaires, notes, etc.</label>
    <div v-if="form.errors.body" class="invalid-feedback">
      {{ form.errors.body }}
    </div>
    <div class="d-flex justify-content-end">
      <button
        :disabled="form.processing"
        type="submit"
        class="btn btn-primary btn-sm my-2"
      >
        Sauvegarder le commentaire
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    entityType: {
      type: String,
      required: true,
      validator(value) {
        return ['sections', 'chapters', 'themes'].includes(value)
      },
    },
    entityNumber: {
      type: String,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        body: null,
      }),
      wasValidatedOnce: false,
    }
  },
  computed: {
    textAreaReference() {
      return `textarea-${this.entityType}-${this.entityNumber}`
    },
    isGuest() {
      return this.$page.props.is_guest
    },
    showForm() {
      return !this.isGuest
    },
    isDisabled() {
      return this.form.processing || this.unavailableFeature
    },
    currentSurvey() {
      return this.$page.props.survey
    },
    currentSurveyId() {
      return this.currentSurvey.id
    },
    entityComments() {
      return this.currentSurvey.comments[this.entityType] ?? []
    },
    currentEntityComment() {
      for (let i = 0; i < this.entityComments.length; i++) {
        if (this.entityComments[i].entity_id == this.entity.id) {
          return this.entityComments[i].body
        }
      }
      return null
    },
    postParameters() {
      return {
        id: this.currentSurveyId,
        entityType: this.entityType,
        entityId: this.entity.id,
      }
    },
  },
  beforeMount() {
    if (this.showForm && this.currentSurvey.comments) {
      this.initBody()
    }
  },
  methods: {
    submit() {
      this.wasValidatedOnce = false
      this.form.post(
        this.$route('survey.user.setEntityComment', this.postParameters),
        {
          preserveScroll: true,
          onSuccess: () => this.$toasted.global.saved(),
          onError: (error) => {
            console.error(error)
            this.$toasted.global.savingError()
          },
          onFinish: () => (this.wasValidatedOnce = true),
        }
      )
    },
    getValidationClass(key) {
      return this.form.errors[key] && this.wasValidatedOnce
        ? 'is-invalid'
        : null
    },
    initBody() {
      this.form.body = this.currentEntityComment
    },
  },
}
</script>
